import { MyTeamContainer } from "./container";

export const MyTeamPage = () => {
  return <MyTeamContainer />;
};
